import {STEPS} from '../settings.js'
import {handleError} from '../utils.js'
import {fuelTypesIcons} from './settings.js'

export const getInitialProps = async ({routeInfo, context: {domain, i18n}}) => {
  const {
    location: {state}
  } = routeInfo

  const config = domain.get('config')

  const {
    VEHICLE_SUGGESTER_PATH_PATTERN: homeSuggesterPath,
    VEHICLE_SUGGESTER_FUEL_TYPE_PAGE_NAME: pageName,
    VEHICLE_SUGGESTER_SEATS_PATH_PATTERN: nextPagePath,
    VEHICLE_SUGGESTER_BODY_TYPE_PATH_PATTERN: previousPagePath
  } = config.get('page')

  const [error, fuelTypesOptionsResponse] = await domain
    .get('get_configurator_fuel_types_options_vehicles_use_case')
    .execute({
      priceFrom: state?.priceRange?.from,
      priceTo: state?.priceRange?.to,
      bodyTypeIds: state?.bodyTypeIds
    })
  if (error) {
    return handleError({
      domain,
      i18n,
      error,
      message: 'Error fetching fuel types options',
      redirectTo: homeSuggesterPath
    })
  }

  const fuelTypeOptions = fuelTypesOptionsResponse.getFilterOptions().map(option => ({
    ...option,
    icon: fuelTypesIcons[option.id]
  }))

  return {
    description: i18n.t('VEHICLE_SUGGESTER.STEP_FUEL_TYPES.DESCRIPTION'),
    h1: i18n.t('COMMON.SUGGESTER'),
    nextPagePath,
    fuelTypeOptions,
    pageName,
    previousPagePath,
    step: STEPS.FUEL_TYPES,
    stepBreadcrumb: i18n.t('COMMON.FUEL'),
    title: i18n.t('VEHICLE_SUGGESTER.STEP_FUEL_TYPES.TITLE')
  }
}
